<template>
  <li
    class="notification-item"
    v-bind:class="{ new: isNew }">
    <button class="notification-item__header" type="button" v-on:click="onClick">
      <p class="notification-item__date">{{ notification.base.dateTime }}</p>
      <h3
        class="notification-item__caption"
        v-bind:class="{ active: isOpen }">
        {{ notification.base.title }}
      </h3>
    </button>
    <notification-item-body v-if="isOpen" v-bind:notification="notification" />
  </li>
</template>

<script>
import NotificationItemBody from '@/components/NotificationItemBody.vue';

/**
 * @description Название события просмотра уведомления.
 * @type {string}
 */
const NAME_EVENT_NOTIFICATION_VIEW = 'notification-view';

/**
 * @description Уведомление.
 * @type {any}
 */
export default {
  components: { NotificationItemBody },
  computed: {
    isNew() {
      return !this.notification.base.isViewed;
    },
  },
  data() {
    return {
      /**
       * @description Открыто ли уведомление.
       * @type {boolean}
       */
      isOpen: false,
    };
  },
  methods: {
    /**
     * @description Обработать клик.
     * @returns {void}
     */
    onClick() {
      this.isOpen = !this.isOpen;
      if (this.isOpen && this.isNew) {
        this.$emit(NAME_EVENT_NOTIFICATION_VIEW, this.notification.base.id);
      }
    },
  },
  props: {
    /**
     * @description Уведомление.
     * @type {Object}
     */
    notification: { required: true, type: Object },
  },
};
</script>

<style scoped lang="scss">
.notification-item {
  border-radius: 10px;
  border: 1px solid #eaeff3;
  list-style: none;
  padding: 20px;
  cursor: pointer;
  &.new {
    background: #eaeff3;
  }
  &:hover {
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  }
  &__header {
    text-align: left;
    width: 100%;
  }
  &__date {
    color: #0489e0;
    margin: 0;
    font-size: 14px;
  }
  &__caption {
    display: flex;
    align-items: flex-end;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    margin: 5px 0 10px 0;
    &:after {
      content: "";
      background-image: url("@/assets/img/checked/checked-black.svg");
      background-position: center;
      background-repeat: no-repeat;
      margin: 0 0 0 10px;
      width: 20px;
      min-width: 20px;
      height: 24px;
      min-height: 24px;
    }
    &.active:after {
      background-image: url("@/assets/img/checked/checked-black-top.svg");
    }
    &:hover {
      text-decoration: underline;
    }
  }
}

</style>
